import { useState, useEffect } from "react";
import axios from "axios";
import { Newspaper, Calendar } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function MemberNews() {
  const [notizie, setNotizie] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { axios.get(`${API}/notizie`).then(r => setNotizie(r.data)).catch(() => {}).finally(() => setLoading(false)); }, []);

  if (loading) return <div className="text-center py-12 text-white/30">Caricamento notizie...</div>;

  return (
    <div data-testid="member-news" className="space-y-3">
      <p className="text-sm text-white/40 mb-4">{notizie.length} notizie</p>
      {notizie.map(n => (
        <div key={n.id} className="glass-card rounded-lg border border-white/8 p-5" data-testid={`member-news-${n.id}`}>
          <div className="flex items-start gap-4">
            <div className="w-10 h-10 rounded-md bg-[#00A0D1]/10 border border-[#00A0D1]/20 flex items-center justify-center flex-shrink-0 mt-0.5">
              <Newspaper className="w-5 h-5 text-[#00A0D1]" />
            </div>
            <div className="flex-1">
              <h3 className="text-base font-semibold text-white mb-1" style={{ fontFamily: 'Outfit, sans-serif' }}>{n.titolo}</h3>
              <p className="text-sm text-white/40 leading-relaxed whitespace-pre-wrap">{n.contenuto}</p>
              <div className="flex items-center gap-4 mt-3">
                <p className="text-xs text-white/20">di {n.autore}</p>
                <div className="flex items-center gap-1 text-xs text-white/20"><Calendar className="w-3 h-3" /> {new Date(n.created_at).toLocaleDateString('it-IT', { day: 'numeric', month: 'long', year: 'numeric' })}</div>
              </div>
            </div>
          </div>
        </div>
      ))}
      {notizie.length === 0 && <div className="text-center py-12 text-white/30">Nessuna notizia disponibile</div>}
    </div>
  );
}
